/* eslint-disable react/require-default-props */

import React from 'react';
import PropTypes from 'prop-types';
import { ActionPromiseButton } from './ActionPromiseButton';

export const ActionButton = (props) => (
  <ActionPromiseButton
    {...{ ...props }}
    onClick={() => new Promise((res, rej) => props.onClick(res, rej))}
  />
);

ActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  colour: PropTypes.string,
  shape: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  className: PropTypes.string,
};
